import {CONSTANTS} from "../common/constants";

export interface File {
    display_name: string
    url: string
    size: string
    extension: string
    name: string
    notes: string
}

export interface FileSection {
    is_files_visible: boolean,
    files: File[]
    audio_file: File | null;
    audio_file_text: string;
}

export class FileType {
    private extensions: { [fileType: string]: string[] } = {
        [CONSTANTS.FILE_TYPES.IMAGE]: ['.tif', '.tiff', '.bmp', '.jpg', '.jpeg', '.gif', '.png', '.ico'],
        [CONSTANTS.FILE_TYPES.DOCUMENT]: [
            // Presentations
            '.key', '.odp', '.pps', '.ppt', '.pptx',
            // Spreadsheet
            '.ods', '.xls', '.xlsm', '.xlsx',
            //Word and text
            '.doc', '.docx', '.odt', '.rtf', '.tex', '.txt', '.wpd'

        ],
        [CONSTANTS.FILE_TYPES.PDF]: ['.pdf'],
        [CONSTANTS.FILE_TYPES.VIDEO]: [
            '.3g2', '.3gp', '.avi', '.flv', '.h264', '.m4v', '.mkv', '.mov', '.mp4',
            '.mpg', '.mpeg', '.swf', '.wmv'
        ]
    };

    public fileType: string;

    constructor(private file: File) {
        this.fileType = this.getFileType();
    }

    public getFileType() {
        let fileType = CONSTANTS.FILE_TYPES.OTHER;

        for (let currentFileType of Object.keys(this.extensions)) {
            let typeExtensions = this.extensions[currentFileType];

            if (typeExtensions.some(typeExtension => typeExtension === this.file.extension.toLowerCase())) {
                fileType = currentFileType;
            }
        }

        return fileType;
    }

    public isPDF() {
        return this.fileType === CONSTANTS.FILE_TYPES.PDF;
    }

    public isDocument() {
        return this.fileType === CONSTANTS.FILE_TYPES.DOCUMENT;
    }

    public isImage() {
        return this.fileType === CONSTANTS.FILE_TYPES.IMAGE;
    }

    public isVideo() {
        return this.fileType === CONSTANTS.FILE_TYPES.VIDEO;
    }

    public isOther() {
        return this.fileType === CONSTANTS.FILE_TYPES.OTHER;
    }
}